<script setup lang="ts">
import Skeleton from 'primevue/skeleton';

const generateArray = (count: number) => [...Array(count).keys()];
</script>
<template>
  <div class="flex flex-col gap-4 grow-0 w-full h-full">
    <div class="flex gap-6 justify-between flex-wrap">
      <div v-for="idx in generateArray(2)" :key="idx" class="flex-1 w-1/2 lg:w-1/5">
        <Skeleton style="height: 1.75rem;" />
      </div>
    </div>
    <div class="hidden md:flex justify-between grow-0">
      <div class="flex grow-0 gap-2">
        <Skeleton v-for="idx in generateArray(3)" :key="idx" style="height: 1.5rem; width: 8rem" />
      </div>
      <div class="flex grow-0 gap-2">
        <Skeleton v-for="idx in generateArray(6)" :key="idx" style="height: 1.5rem; width: 1.5rem" />
      </div>
    </div>
    <div class="flex grow shrink-0 justify-between">
      <div class="flex md:hidden h-full w-full">
        <Skeleton style="height: 100%; border-radius: 0.5rem;" />
      </div>
      <div class="sm:hidden md:flex gap-4 lg:hidden h-full w-full">
        <Skeleton style="height: 100%; border-radius: 0.5rem;" />
        <Skeleton style="height: 100%; border-radius: 0.5rem;" />
      </div>
      <div class="hidden lg:flex gap-4 h-full w-full">
        <div v-for="idx in generateArray(4)" :key="idx" class="flex-1 w-1/4">
          <Skeleton style="height: 100%; border-radius: 0.5rem;" />
        </div>
      </div>
    </div>
  </div>
</template>
